module.exports = __webpack_public_path__ + "img/img-a3e15fbf.cf7e3737.png";